module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "soft"
  }, [_vm._m(0), _vm._v(" "), _c('h2', {
    staticClass: "has-text-centered"
  }, [_vm._v("Софт")]), _vm._v(" "), _c('draggable', {
    staticClass: "data-container columns is-multiline",
    on: {
      "end": _vm.dragSoftsEnd
    },
    model: {
      value: (_vm.softObject),
      callback: function($$v) {
        _vm.softObject = $$v
      },
      expression: "softObject"
    }
  }, _vm._l((_vm.softObject), function(item) {
    return _c('SoftItem', {
      key: item.id,
      attrs: {
        "data": item
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": function($event) {
        return _vm.handleAddDataForClients('software')
      }
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Добавить ПО\n    ")])]), _vm._v(" "), _c('h2', {
    staticClass: "has-text-centered"
  }, [_vm._v("Инструкции")]), _vm._v(" "), _c('draggable', {
    staticClass: "data-container columns is-multiline",
    on: {
      "end": _vm.dragInstructionEnd
    },
    model: {
      value: (_vm.instructionsObject),
      callback: function($$v) {
        _vm.instructionsObject = $$v
      },
      expression: "instructionsObject"
    }
  }, _vm._l((_vm.instructionsObject), function(item) {
    return _c('SoftItem', {
      key: item.id,
      attrs: {
        "data": item
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": function($event) {
        return _vm.handleAddDataForClients('instruction')
      }
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Добавить инструкцию\n    ")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drag-info"
  }, [_c('div', {
    staticClass: "drag-info-content centered"
  }, [_c('img', {
    staticClass: "drag-icon",
    attrs: {
      "src": "/static/img/icons/move.svg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "has-text-centered"
  }, [_vm._v("\n      Чтобы поменять местами элементы удерживайте и перетаскивайте их "), _c('br')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a7382ed"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About/DataForClients.vue
// module id = 958
// module chunks = 0